import "./singleLocalSite.scss";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import useFetch from "../../../hooks/useFetch";

const SingleLocalSite = () => {
  const [info, setInfo] = useState([]);
  const { siteId } = useParams();
  const  token = localStorage.getItem("token");
  const { data, loading, error } = useFetch(`/localsite/${siteId}`);

  useEffect(() => {
    setInfo(data);
  }, [data]);



  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar/>
        <div className="top">
          {loading ? (
              "loading"
          ) : (
              <div className="left">

                <div>
                  <Link to={`/localsite/update/${siteId}`}>
                    <div className="editButton">Edit</div>
                  </Link>
                </div>
                <div>
                  <Link to={`/localsite/open/${siteId}`}>
                    <div className="timeButton">OPEN ticket</div>
                  </Link>
                </div>




                <h1 className="title">Information Local Site</h1>
                <div className="item">
                  <img
                      src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                      alt=""
                      className="itemImg"
                  />
                  <div className="details">
                    <h1 className="itemTitle">{info.id}</h1>
                    <div className="detailItem">
                      <span className="itemKey">Site Name : </span>
                      <span className="itemValue">{info.name_site}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">STATUS SITE : </span>
                      <span className="itemValue">{info.status_site}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">POP ID : </span>
                      <span className="itemValue">{info.pop_id}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Bandiwth : </span>
                      <span className="itemValue">{info.bandwith}</span>
                    </div>
                  </div>
                </div>
              </div>)}

        </div>
        <div className="bottom">
        </div>
      </div>
    </div>
  )
      ;
};

export default SingleLocalSite;
